export default __webpack_public_path__ + "static/ifst-logo-b225ab72e9676b1e385aad81babffa78.png";